<template>
    <div>
        <el-dialog class="login common-dialog noHeader" title="" :visible="isShowModal"
                   :close-on-click-modal="false"
                   :before-close="closeLoginDialog">
            <div class="title">
                <h2>快速登录</h2>
                <h3>
                    <el-button type="text" @click="switchLogin('sms')" :class="loginState==='sms'&&'active'">手机验证码登录</el-button>
                    <el-button type="text" @click="switchLogin('pwd')" :class="loginState==='pwd'&&'active'">密码登录（手机号)</el-button>
                </h3>
            </div>
            <el-form :model="loginForm" :rules="rules" ref="loginForm" class="loginForm">
                <el-form-item prop="phone">
                    <el-input ref="phoneNum" v-model="loginForm.phone" placeholder="手机号" :value="loginForm.phone">
                        <i class="icon icon-phone" slot="prepend"></i>
                    </el-input>
                </el-form-item>

                <el-form-item v-if="loginState==='sms'" prop="authCode">
                    <el-input v-model="loginForm.authCode" placeholder="短信验证码">
                        <i class="icon icon-sms-code" slot="prepend"></i>
                        <template slot="append">
                            <el-button class="authcode-btn"
                                       :disabled="!!countDown"
                                       @click="checkUserWhite()">
                                {{this.countDown?this.countDown+'S': '获取验证码'}}
                            </el-button>
                        </template>
                    </el-input>
                </el-form-item>

                <el-form-item v-if="loginState==='pwd'" prop="password">
                    <el-input v-model="loginForm.password" type="password" placeholder="密码">
                        <i class="icon icon-password" slot="prepend"></i>
                    </el-input>
                </el-form-item>
                <div class="agreement">登录即表示您已阅读并同意<span  @click="handleFaq()">《旋涡服务协议》</span></div>
                <el-button class="login-btn" type="primary" size="full" :loading="loginLoading" @click="submitLogin()">
                    {{loginState === 'sms' ? '手机验证码登录' : '登录'}}
                </el-button>
            </el-form>
        </el-dialog>

        <el-dialog class="common-dialog noHeader white-dialog" title="" :visible.sync="whiteDialog">
            <div class="white-qrcode">
                <span></span><span></span><span></span><span></span>
                <img src="../../content/images/qrcode-gzh.jpg" alt="旋涡营销公众号">
            </div>
            <p>微信扫一扫，立即获取体验资格</p>
        </el-dialog>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import Validate from '../../store/validate'
import Utils from '../../store/utils'
export default {
    data() {
        return {
            loginState: 'sms',
            countDown: 0,
            loginForm: {
                sex: '',
                phone: '',
                authCode: '',
                password: ''
            },
            rules: {
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { validator: Validate.validatePhone, trigger: 'blur' }
                ],
                authCode: [
                    { required: true, message: '请输入验证码', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' }
                ]
            },
            whiteDialog: false,
            loginLoading: false
        }
    },
    async created() {
        let user = Utils.getCookie('XW_U');
        if (user) {
            user = user.split(',');
            this.loginForm.phone = user[0];
        }
        let param = this.$route.query;
        if (param.access_token) {
            let data = await this.externalAuthUser({token: param.access_token});
            this.setUser(data);
            if (!data.newCommer) {
                await this.getTypeLog();
                Utils.setCookie('XW_U', data.phone, 1, 'y');
                this.showLoginSuccessTip();
                this.closeLoginDialog();
                this.updateMessage();
                setTimeout(() => {
                    this.loginLoading = false;
                }, 1000);
            }else{
                this.setNewCommer(true);
                this.setLoginStep('sex');
            }
        }
    },
    computed: {
        isShowModal() {
            return this.loginStep === 'login';
        },
        ...mapState({
            loginStep: 'loginStep',
            user: 'user'
        })
    },
    methods: {
        ...mapMutations(['closeLoginDialog','bdTrackEvent', 'setUser', 'setNewCommer', 'setLoginStep']),
        ...mapActions(['loginUser', 'sendPhoneCode', 'loginVerify', 'hasUserWhite']),
        ...mapActions('message', ['updateMessage']),
        ...mapActions('welfare',[ 'addShareLog','getTypeLog']),
        ...mapActions('external',['externalAuthUser']),
        handleFaq (){
            let routeData = this.$router.resolve({ path: '/faq-protocol' });
            window.open(routeData.href, '_blank');
        },
        //切换登录形式
        switchLogin(val) {
            if (this.loginState !== val) {
                this.loginState = val;
                //重置表单验证
                this.$refs['loginForm'].resetFields();
            }
        },
        validateLogin() {
            return new Promise((resolve, reject) => {
                this.$refs['loginForm'].validate(valid => {
                    if (valid) {
                        resolve(valid);
                    } else {
                        reject('填写信息有误，请确认');
                        return false;
                    }
                });
            });
        },
        //验证输入数据
        checkUserWhite() {
            this.$refs['loginForm'].validateField('phone');
            if (!this.loginForm.phone || !Validate.getValidate('phone').test(this.loginForm.phone)) {
                return;
            }
            this.sendSmsCode();
        },
        sendSmsCode() {

            if (this.countDown) {
                this.$message({ message: '1分钟内不能重复发送验证码！', type: 'warning' });
                return;
            }

            this.countDown = 60;
            var interval;
            this.sendPhoneCode({ phoneNum: this.loginForm.phone }).then(data => {
                this.$message({ message: '验证码发送成功', type: 'success' });
                interval = setInterval(() => {
                    this.countDown--;
                    if (!this.countDown) {
                        clearInterval(interval);
                    }
                }, 1000);
            }, error => {
                this.countDown = 0;
                this.$message({ type: 'error', message: error });
                clearInterval(interval);
            });
        },
        showLoginSuccessTip() {
            this.$message({ type: 'success', message: `恭喜 ${this.user.name || this.user.phone} 登录成功!` });
        },
        //提交登录
        async submitLogin() {

            this.bdTrackEvent(['首页', this.loginState === 'sms' ? '（未登录状态）点击手机验证码登录，蓝色按钮':'（未登录状态）点击密码登录，蓝色按钮'])
            this.loginLoading = true;
            try {
                await this.validateLogin();
                let data;
                if (this.loginState === 'pwd') {
                    data = await this.loginUser({ data: this.loginForm, type: this.loginState });
                } else {
                    data = await this.loginVerify({ data: this.loginForm, type: this.loginState });
                }
                if(this.user.wxopenid2){
                    await this.addShareLog({conditionType:2});
                }
                if(this.user.password){
                    await this.getTypeLog();
                }
                this.$refs['loginForm'].resetFields();
                if (!data.newCommer) {
                    Utils.setCookie('XW_U', data.phone + (this.loginForm.password ? ','+this.loginForm.password : ''), 1, 'y');
                    this.showLoginSuccessTip();
                    this.closeLoginDialog();
                    this.updateMessage();
                }
                setTimeout(() => {
                    this.loginLoading = false;
                }, 1000);

            } catch (error) {
                this.loginLoading = false;
                this.$message({ type: 'error', message: error });
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.title {
    $lineHeight: 24; //$padding: 10;
    position: relative;
    text-align: center; //padding: $padding+px 0 40px;
    span {
        display: block;
        position: absolute; //top: $lineHeight/2+$padding + px;
        left: 0;
        width: 100%;
        height: 0;
        border-bottom: 1px solid #ccc;
    }
    h2 {
        position: relative;
        z-index: 1;
        width: 30%;
        margin: 0 auto;
        line-height: $lineHeight + px;
        background-color: #fff;
    }
    h3 {
        position: relative;
        .el-button--text {
            color: #a8a8a8;
            font-size: 0.8rem;
            width: 8rem;
        }

        .active {
            color: #1f1f1f;
        }
        &::before {
            content: '';
            position: absolute;
            width: 6.25rem;
            border-bottom: 1px solid #d3e3fa;
            top: 0.88rem;
            left: 0;
        }
        &::after {
            content: '';
            position: absolute;
            width: 6.25rem;
            border-bottom: 1px solid #d3e3fa;
            top: 0.88rem;
            right: 0;
        }
    }
}
.agreement{
    position: relative;
    &::before {
        content: '';
        position: absolute;
        width: 6.25rem;
        border-bottom: 1px solid #d3e3fa;
        top: 0.6rem;
        left: 0;
    }
    &::after {
        content: '';
        position: absolute;
        width: 6.25rem;
        border-bottom: 1px solid #d3e3fa;
        top: 0.6rem;
        right: 0;
    }
    margin-bottom: 1rem;
    text-align: center;
    font-size: 0.8rem;
  span{
      cursor: pointer;
      &:hover{
          color: #2472E8;
      }
  }
}
.authcode-btn.is-disabled:hover {
    background-color: transparent;
    border-color: transparent;
}
</style>

<style lang="scss">
.login {
    .el-dialog {
        width: 42.1rem;
        height: auto;
    }
    .el-dialog__header {
        padding: 3rem 20px 0;
    }
    .el-dialog__body {
        margin: 0;
        padding: 0 5rem 4.35rem;
    }
}

.loginForm {
    .el-input {
        /*width: 32rem;*/
        /*height: 3rem;*/
        input {
            //border-left: 0;
            height: 48px;
            /*line-height: 2.9rem;*/
            font-size: 1rem;
        }
        .icon {
            background-image: url(../../content/images/login-form-icon.png);
            background-size: 4.65rem 1.25rem;
            background-repeat: no-repeat;
            width: 1.2rem;
            height: 1.25rem;
            display: block;
        }
        .icon-phone {
            background-position: 0 0;
        }
        .icon-password {
            background-position: -2.60rem 0;
        }
        .icon-sms-code {
            margin-top: 0.4rem;
            background-position: -1.2rem -0.2rem;
        }
    }
    .login-btn {
        height: 3rem;
        font-size: 1.3rem;
        letter-spacing: 2px;
    }

    p {
        color: #175199;
        margin-top: 0;
        margin-bottom: 23px;
    }

    .is_error .el-input-group__prepend {
        border-color: red;
    }

    .el-input-group__prepend:focus {
        border-color: #2573e8;
    }
}
/*不在用户白名单提示框*/
.white-dialog .el-dialog {
    width: 623px;
    height: 461px;
    text-align: center;
    .el-dialog__header{
        padding: 0;
    }
    .el-dialog__body {
        padding: 47px 0 0;
    }
    @mixin imgBorder($top, $right, $bottom, $left) {
        position: absolute;
        top: $top;
        right: $right;
        bottom: $bottom;
        left: $left;
        width: 36px;
        height: 36px;
        border: 1px solid #000;
    }
    .white-qrcode {
        position: relative;
        width: 291px;
        margin: 0 auto;
        padding: 1px;
        font-size: 0;
        border: 1px solid #e4e4e4;
        span:nth-child(1) {
            @include imgBorder(0, auto, auto, 0);
        }
        span:nth-child(2) {
            @include imgBorder(0, 0, auto, auto);
        }
        span:nth-child(3) {
            @include imgBorder(auto, auto, 0, 0);
        }
        span:nth-child(4) {
            @include imgBorder(auto, 0, 0, auto);
        }
        img {
            position: relative;
            width: 100%;
        }
    }
    p {
        font-size: 28px;
        color: #666;
    }
}
</style>



// WEBPACK FOOTER //
// app/view/login/Login.vue